import parentDefaults from '../ssjrvnvryr-1/config.js';

export default {
  ...parentDefaults,
  includes: [  ...parentDefaults.includes, 'ssjrvnvryr-1'],
};
